<template>
  <div :class="classObj" class="ccui-app-wrapper">
    <div class="ccui-main-container">
      <!-- 应用导航 -->
      <el-top-nav-menu-3
        v-if="menu.length > 0"
        id="ccui-top-nav-menu"
        ref="topNavMenu"
        :subMenu="menu"
        :appTitle="appTitle"
        :companyTitle="companyTitle"
        class="no-print"
        @onSubmitSkip="onJump"
        dashboard=""
        @ccuiHelp="appHelp"
        :logo="orgLogo"
      >
      </el-top-nav-menu-3>
      <div class="ccui-main-wrapper">
        <!-- 左侧菜单 -->
        <div
          v-show="sidebar.opened"
          class="ccui-sidebar-wrapper no-print"
          :style="{ position: sidebarPosition }"
        >
          <div :style="{ minHeight: sidebarMinHeight }">
            <sidebar
              :title="subMenuTitle"
              :left-menu="currentMenuArr"
              class="ccui-sidebar-container"
            />
          </div>
        </div>
        <!-- 内容区 -->
        <app-main style="min-height: auto" />
      </div>
      <el-simple-footer
        class="ccui-home-index-footer"
        v-if="isShowSimpleFooter"
      ></el-simple-footer>
    </div>
    <feedback ref="feedbackData"></feedback>
  </div>
</template>

<script>
import { Sidebar, AppMain } from "./components";
import Cookies from "js-cookie";
import arrows from "@/basa/assets/images/arrows.png";
import { getDetail, getLogin } from "@/config/api/login";
import { getArgs } from "@/basa/utils";
import { goIccec, getUserInfo } from "@/config/api/login";
import feedback from "./components/feedback/feedback.vue";
export default {
  name: "Layout",
  components: {
    Sidebar,
    AppMain,
    feedback
  },
  data() {
    return {
      dashboard: "/helpAndSupport",
      companyTitle: "", //组织名称
      appTitle: "", //应用名称
      orgLogo: require("@/assets/images/zj_logo.png"),
      newVal: "",
      arrows,
      counter: 0,
      isShowSidebar: false,
      topMenuObj: {},
      routeMenu: [],
      leftMenu: [],
      subMenuTitle: "",
      currentMenuObj: {},
      currentParentMenuObj: {},
      tempMenu: [],
      activeIndex: "2",
      sidebarPosition: "absolute",
      sidebarMinHeight: "calc(100vh - 160px)"
    };
  },
  computed: {
    menu4() {
      return this.$store.state.app.menu4;
    },
    isShowSimpleFooter() {
      return this.$store.state.app.isShowSimpleFooter;
    },
    menu() {
      return this.$store.state.app.menu || [];
    },
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened
      };
    },
    currentMenuArr() {
      return this.$store.state.app.currentMenuArr;
    }
  },
  created() {
    this.getDetail();
    this.getUserInfo();
    this.$store.dispatch("setMenu4", [
      "/contractProject/Menu4",
      "/productionManage/productionProject"
    ]);
  },
  mounted() {
    if (this.$route.path === "/test/test") {
      console.log(goIccec);
      return;
    }
    this.setMenuInit();

    const sidebarStatus = Cookies.get("sidebarStatus") - 0;
    this.isShowSidebar = !!sidebarStatus;

    window.addEventListener("scroll", this.windowScroll);

    const loadingOverlay = document.querySelector(".loading-overlay");
    loadingOverlay && (loadingOverlay.style.display = "none");

    window.addEventListener("setItem", () => {
      this.newVal = sessionStorage.getItem("languageChangeHandler1");
    });
  },
  watch: {
    newVal(e) {
      this.$refs.feedbackData.dialogFormVisible = e === "true";
    },
    $route(to, from) {
      this.setMenuInit();
    }
  },
  methods: {
    getUserInfoHandler(res) {
      this.isShowTopBar = true;
      this.isShowCenter = true;
      this.oftenUse = res.data.data.mOrganizations;
      if (this.oftenUse.length) {
        this.oftenUse[0].orgName = "常用功能";
      }
      let userInfo = res.data.data.userInfo;
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      const arr = res.data.data.umOrganizations;
      arr.forEach((item, i) => {
        if (i === 0) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      });
      // this.orgArrPrivate = arr.concat(arr).concat(arr);
      this.orgArrPrivate = arr;
      // 测试一个单位情况
      // this.orgArrPrivate.length = 1;
      // 把该应用下所有单位连接存入sessionStorage
      // const orgsOnApp = [];
      // console.log(window.location.hostname);
      // arr.forEach(org => {
      //   org.appList.forEach(app => {
      //     // debugger
      //     let hostname = window.location.hostname;
      //     // hostname = "dev01-demo.iccec.cn"
      //     if (app.url.indexOf(hostname) !== -1) {
      //       console.log(app);
      //       app.isShow = window.location.search.indexOf(app.agentId) > -1;
      //       app.orgName = org.orgName;
      //       app.logoComUrl = org.logoComUrl;
      //       orgsOnApp.push(app);
      //     }
      //   });
      // });
      // console.log("orgsOnApp", orgsOnApp);
      // sessionStorage.setItem("orgsOnApp", JSON.stringify(orgsOnApp));
      // const timer = setInterval(() => {
      //   let orgsOnAppStr = sessionStorage.getItem("orgsOnApp");
      //   if (orgsOnAppStr) {
      //     clearInterval(timer);
      //     this.$refs.topNavMenu.orgsOnApp = JSON.parse(orgsOnAppStr);
      //   }
      // }, 1000);
    },
    async getUserInfo() {
      // 获取用户数据
      let res = await getUserInfo({});
      if (res.data.code === "0") {
        localStorage.setItem(
          "user-msg",
          JSON.stringify(res.data.data.userInfo)
        );
        this.getUserInfoHandler(res);
      } else if (res.data.code === "111") {
        this.isShowTopBar = true;
      } else if (res.data.code === "997") {
        // 第二次
        setTimeout(async () => {
          let res = await getUserInfo({});
          if (res.data.code === "0") {
            this.getUserInfoHandler(res);
          } else if (res.data.code === "111") {
            this.isShowTopBar = true;
          } else if (res.data.code === "997") {
            // 第三次
            setTimeout(async () => {
              let res = await getUserInfo({});
              if (res.data.code === "0") {
                this.getUserInfoHandler(res);
              } else if (res.data.code === "111") {
                this.isShowTopBar = true;
              } else if (res.data.code === "997") {
                // 第三次后清缓存和Cookie
                this.clearCookie();
                if (!getArgs("a")) {
                  // eslint-disable-next-line no-self-assign
                  window.location.href = window.location.href;
                }
              }
            }, 2000);
          }
        }, 2000);
      }
    },
    appHelp() {
      // debugger;
      this.$router.push("/helpAndSupport");
    },
    setMenuInit() {
      this.$store.dispatch("setMenu", this.menu);

      // 这里控制用哪一级路由来定位菜单
      if (this.$route.matched && this.$route.matched.length > 2) {
        this.setMenu(this.$store.state.app.menu, this.$route.matched[1].name); // 四级用三级的name做定位菜单
      } else {
        this.setMenu(this.$store.state.app.menu, this.$route.name); // this.$route.name 用于定位菜单
      }
    },
    getDetail() {
      getDetail({ agentId: getArgs("a") }).then(res => {
        if (res.data.code === "0") {
          this.companyTitle = res.data.data.orgFullName;
          // localStorage.setItem("orgFullName", this.companyTitle);
          let agentName = res.data.data.agentName;
          // this.orgLogo = res.data.data.agentLogo;
          // 面包屑所用
          this.$store.dispatch("setBreadcrumb", {
            level: "level1",
            data: {
              name: agentName,
              path: "/"
            }
          });
          this.appTitle = agentName;
          this.$store.commit("SET_USER_DETAL", res.data.data);
          sessionStorage.setItem("userDetal", JSON.stringify(res.data.data));
        }
      });
      getLogin({}).then(res => {
        if (res.data.code === "0") {
          this.$store.commit("SET_USER_ID", res.data.data.userId);
        }
      });
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    // 点击菜单
    onJump(obj) {
      this.routeMenu = [];
      this.subMenuTitle = "";
      this.$router.push(obj.url);
    },
    routerObj2MenuObj(item) {
      const menuObj = {};
      menuObj.subMenuTitle = item.name;
      if (item.subMenu.length) {
        const subMenuArr = [];
        item.subMenu.forEach(menuItem => {
          subMenuArr.push(this.trans(menuItem));
        });
        menuObj.subMenu = subMenuArr;
      }
      return menuObj;
    },
    setMenuToRoute(obj) {
      if (obj.subMenu.length) {
        const arr = obj.subMenu;
        const arrMenu = [];

        arr.forEach(item => {
          const menuObj = this.routerObj2MenuObj(item);
          arrMenu.push(menuObj);
        });
        this.$store.dispatch("setCurrentMenuArr", arrMenu);

        this.leftMenu = this.$store.state.app.currentMenuArr;

        this.subMenuTitle = obj.subMenu[0].name;

        const routeObj = this.trans(obj);
        const subMenu = [];
        obj.subMenu.forEach(item => {
          if (item.subMenu.length) {
            item.subMenu.forEach(item => {
              const objTemp = this.trans(item);
              subMenu.push(objTemp);
            });
            routeObj.children = subMenu;
          }
        });

        this.routeMenu = subMenu;
      }
    },
    trans(obj) {
      const _routeObj = {};
      _routeObj.name = obj.name;
      _routeObj.path = obj.url;
      _routeObj.redirect = obj.redirect || "";
      _routeObj.meta = obj.meta || {};
      _routeObj.meta.title = obj.name;
      _routeObj.meta.isNotShow = obj.isNotShow;
      // 新加--实现四级菜单
      if (this.menu4.includes(obj.url)) {
        _routeObj.children = [];
        _routeObj.flag = true;
        obj.sons.forEach(menuItem => {
          _routeObj.children.push(this.trans(menuItem));
        });
      }
      return _routeObj;
    },
    setMenu(arr, menuCode) {
      const that = this;

      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取当前菜单
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].menuCode === menuCode) {
                // 获取当前菜单的父菜单
                that.currentMenuObj = arr[i];
                that.setParentMenu(that.menu, arr[i].pid, arr[i].id);
              }
            }
          }
        };
        traverse(arr);
      }
    },
    setParentMenu(arr, pid, index) {
      if (arr.length !== 0) {
        var traverse = arr => {
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].subMenu && arr[i].subMenu.length !== 0) {
              // 获取父菜单
              if (arr[i].id === pid) {
                // 获取三级菜单的上级菜单
                if (arr[i].id.split("-").length === 2) {
                  this.currentParentMenuObj = arr[i];
                  arr[i].activeIndex = index;
                  // return
                }
                // 获取二级菜单的上级菜单
                if (arr[i].id.split("-").length === 1) {
                  arr[i].activeIndex = index;
                }

                // 设置上级菜单
                this.setParentMenu(this.menu, arr[i].pid, arr[i].id);
              }
              traverse(arr[i].subMenu);
            } else {
              if (arr[i].id === pid) {
                arr[i].activeIndex = index;
              }
            }
          }
        };
        traverse(arr);
      }

      if (
        this.currentParentMenuObj.subMenu &&
        this.currentParentMenuObj.subMenu.length
      ) {
        this.setMenuToRoute(this.currentParentMenuObj);
      }
    },
    windowScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.sidebarPosition = scrollTop >= 120 ? "fixed" : "absolute";
      this.sidebarMinHeight =
        scrollTop >= 120
          ? "calc(100vh - 40px)"
          : `calc(100vh - ${160 - scrollTop}px)`;
    }
  }
};
</script>
